import { render, staticRenderFns } from "./LocationProducts.vue?vue&type=template&id=27239ba1&scoped=true"
import script from "./LocationProducts.vue?vue&type=script&lang=js"
export * from "./LocationProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27239ba1",
  null
  
)

export default component.exports